import { createFeatureSelector, createSelector } from '@ngrx/store';

import { NotificationsState } from './notifications.state';

export const NOTIFICATIONS_STATE_NAME = '[notifications] Notifications';

export const FETCH_NOTIFICATIONS_COUNT_START =
	'[notifications] fetch notifications count start';
export const FETCH_NOTIFICATIONS_COUNT_SUCCESS =
	'[notifications] fetch notifications count success';
export const FETCH_NOTIFICATIONS_COUNT_FAILURE =
	'[notifications] fetch notifications count failure';

export const FETCH_NOTIFICATIONS_START =
	'[notifications] fetch notifications start';
export const FETCH_NOTIFICATIONS_SUCCESS =
	'[notifications] fetch notifications success';
export const FETCH_NOTIFICATIONS_FAILURE =
	'[notifications] fetch notifications failure';

export const UPDATE_NOTIFICATION_STATUS_SUCCESS =
	'[notifications] update notification status success';

const selectNotificationsState = createFeatureSelector<NotificationsState>(
	NOTIFICATIONS_STATE_NAME,
);
export const selectNotificationsCount = createSelector(
	selectNotificationsState,
	(state) => state.count,
);
